<template>
  <div class="original-exam">
    <v-base-card>
      <template v-slot:heading>
        問題作成条件
      </template>

      <template v-slot:content>
        <p class="float-right requred__text"><font color="#ff4a3d" size="2">❇︎</font>は必須項目です</p>
        <!-- コース選択 -->
        <v-section-panel useBreak>
          <template v-slot:title> 教科書・単語集選択 <font color="#ff4a3d" size="2">❇︎</font></template>
          <template v-slot:content>
            <v-choice-search-types/>
          </template>
        </v-section-panel>

        <!-- コース以降の選択肢は別コンポーネントへ -->
        <!-- 教科書の場合 -->
        <v-select-publisher-mode class="mb-4" v-if="selectedPublisherMode"/>
        <!-- ゲットスルーの場合-->
        <v-select-get-through-mode v-else-if="selectedGetThroughMode"/>

        <!-- 問題作成ボタン -->
        <v-btn color="secondary" v-if="showCreateBtn" @click="questionCreate">問題作成</v-btn>

      </template>

    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceSearchTypes from '@/components/molecules/ChoiceSearchTypes'
import VSelectPublisherMode from '@/components/molecules/SelectPublisherMode'
import VSelectGetThroughMode from '@/components/molecules/SelectGetThroughMode'
import config from '../../config'

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VChoiceSearchTypes,
    VSelectPublisherMode,
    VSelectGetThroughMode,
  },

  mounted() {
    this.$gtag.pageview({
      page_path: '/create_print',
      page_title: "問題作成画面"
    })
  },

  computed: {
    selectedPublisherMode() {
      return this.$store.state.conditions.selectedSearchType === config.searchType.PUBLISHER ? true : false
    },
    selectedGetThroughMode() {
      return this.$store.state.conditions.selectedSearchType === config.searchType.GET_THROUGH ? true : false
    },
    showCreateBtn() {
    let result = false
    if(this.$store.state.conditions.selectedCategory > 0) {
      if(this.$store.state.conditions.selectedCategory === 2) {
        //応用問題の場合は、例文・活用・反意語のいずれかにチェックがついている場合のみtrue
        if((this.$store.state.conditions.checkedArr['reibun'].length > 0 && this.$store.state.conditions.checkedArr['target'].length!==0 && this.$store.state.conditions.checkedArr['eiwa'].length!==0)
          || this.$store.state.conditions.checkedArr['katsuyo'].length > 0
          || this.$store.state.conditions.checkedArr['hanigo'].length > 0) {
          result = true
        }
      } else {
        //見出し・テーマ別の場合(単語・連語が選択済みの場合のみtrue)
        if(this.$store.state.conditions.checkedArr['target'].length===0 || this.$store.state.conditions.checkedArr['eiwa'].length===0) result = false
        else result = true
      }
    }
    return result
    }
  },

  methods: {
    async questionCreate() {
      this.$store.commit('conditions/setSavePrintMode', {
        savePrintMode: false
      })
      const validationResult = await this.$store.dispatch('conditions/validate', 'createPrint')
      if (validationResult.status === 'error') {
        this.$toasted.global.error({ message: validationResult.message })
        return
      }

      const searchCountResult = await this.$store.dispatch('conditions/searchCount')
      if (searchCountResult.status === 'error') {
        this.$app.$refs.loading.close()
        this.$toasted.global.error({ message: searchCountResult.message })
        return
      }

      this.$app.$refs.loading.open({type: 'print', message: 'プリント作成中です。少々お待ち下さい。'})

      // 指定範囲の中に入力した設問数存在しない場合はエラーにする
      let hasError = false
      const targetAuestionNumAreas = Object.entries(this.$store.state.conditions.questionNumAreas).filter(([, area]) => area.displayFlg)
      for (let i = 0; i < targetAuestionNumAreas.length; i++ ){
        const area = targetAuestionNumAreas[i][1]
        if (!area.value) continue
        if (area.value > area.maxAvailableWordNum) {
          this.$toasted.global.error({ message: `${area.setsumonTitle}は指定範囲内に${area.maxAvailableWordNum}問しか見つかりませんでした` })
          hasError = true
          this.$app.$refs.loading.close()
          break
        }
      }
      if (hasError) return

      const params = this.$store.getters['conditions/sendApiCommonParams']
      this.$store.dispatch('conditions/questionCreate', params)
        .then((res) => {
          this.$app.$refs.loading.close()
          if (res.status === 'error') this.$toasted.global.error({ message: res.message })
          else this.$router.push('/teacher/saved_print')
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.choice-material__attention
  color #747474

.requred__text
  font-size: 13px;

</style>
